module.exports = __webpack_public_path__ + "static/media/h5_apply_yoga.89a85347.png";